import React from 'react';
import { FileText, Zap, BookOpen, Shield, Lock, CreditCard, Star } from 'lucide-react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="bg-white pt-6 sm:pt-16 pb-12 px-4" data-id="element-160">
      <div className="max-w-4xl mx-auto text-center" data-id="element-161">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-162">
          {/* Eyebrow */}
          <div className="text-brand-blue font-bold text-xs sm:text-sm tracking-[0.2em] uppercase mb-3 sm:mb-6" data-id="element-163">
            PROFE LISTO · NATACIÓN 360
          </div>

          {/* Title — all black, no color split */}
          <h1 className="text-[28px] sm:text-5xl md:text-6xl font-heading font-extrabold text-gray-900 leading-[1.05] tracking-tight mb-4 sm:mb-10" data-id="element-164">
            Todo tu año de pileta <br className="hidden sm:block" data-id="element-165" />
            resuelto de una vez.
          </h1>

          {/* Product image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="relative max-w-2xl mx-auto mb-4 sm:mb-10" data-id="element-166">
            <div className="flex justify-center" data-id="element-167">
              <img src="https://cdn.magicpatterns.com/uploads/1JpSm77P96qK9jcaGaYhKS/281.png" alt="Natación 360 Megapack" loading="eager" decoding="async"
            // @ts-expect-error - fetchpriority is a valid HTML attribute
            fetchpriority="high" className="w-auto max-h-[240px] sm:max-h-[460px] object-contain" data-id="element-168" />
            </div>
          </motion.div>

          {/* Subtitle */}
          <p className="text-sm sm:text-lg text-gray-600 mb-4 sm:mb-8 max-w-2xl mx-auto leading-relaxed" data-id="element-169">
            Megapack NATACIÓN 360 — El sistema completo de ejercicios y
            planificación para el profesor de natación argentino.
          </p>

          {/* Inline pill badges with separators */}
          <div className="flex flex-wrap justify-center items-center gap-x-3 sm:gap-x-4 gap-y-2 mb-4 sm:mb-8 text-[12px] sm:text-sm font-medium text-gray-700" data-id="element-170">
            <div className="flex items-center gap-1.5 sm:gap-2 bg-white px-3 py-1.5 sm:px-4 sm:py-2 rounded-full shadow-sm border border-gray-200" data-id="element-171">
              <FileText className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-brand-blue" data-id="element-172" />
              PDF
            </div>
            <span className="text-gray-300" data-id="element-173">|</span>
            <div className="flex items-center gap-1.5 sm:gap-2 bg-white px-3 py-1.5 sm:px-4 sm:py-2 rounded-full shadow-sm border border-gray-200" data-id="element-174">
              <Zap className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-yellow-500" data-id="element-175" />
              Acceso Inmediato
            </div>
            <span className="text-gray-300 hidden sm:inline" data-id="element-176">|</span>
            <div className="flex items-center gap-1.5 sm:gap-2 bg-white px-3 py-1.5 sm:px-4 sm:py-2 rounded-full shadow-sm border border-gray-200" data-id="element-177">
              <BookOpen className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-brand-blue" data-id="element-178" />
              12 Tomos + 6 Bonus + 2 Élite
            </div>
          </div>

          {/* CTA */}
          <a href="#pricing" className="inline-block w-full sm:w-auto text-center bg-brand-blue hover:bg-brand-dark text-white font-bold text-base sm:text-lg py-3.5 sm:py-4 px-8 sm:px-12 rounded-xl shadow-lg shadow-brand-blue/30 transition-all transform hover:-translate-y-0.5 mb-4 sm:mb-6" data-id="element-179">
            💪 QUIERO MI NATACIÓN 360 AHORA
          </a>

          {/* Trust line */}
          <div className="flex flex-wrap justify-center items-center gap-x-3 sm:gap-x-4 gap-y-2 text-xs sm:text-sm text-gray-500 mb-10" data-id="element-180">
            <div className="flex items-center gap-1.5" data-id="element-181">
              <Shield className="w-3.5 h-3.5 sm:w-4 sm:h-4" data-id="element-182" /> Garantía 7 días
            </div>
            <span className="text-gray-300" data-id="element-183">|</span>
            <div className="flex items-center gap-1.5" data-id="element-184">
              <Lock className="w-3.5 h-3.5 sm:w-4 sm:h-4" data-id="element-185" /> Pago seguro
            </div>
            <span className="text-gray-300 hidden sm:inline" data-id="element-186">|</span>
            <div className="flex items-center gap-1.5" data-id="element-187">
              <CreditCard className="w-3.5 h-3.5 sm:w-4 sm:h-4" data-id="element-188" /> Tarjetas y
              transferencia
            </div>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 pt-8 border-t border-gray-200 max-w-2xl mx-auto" data-id="element-189">
            <div data-id="element-190">
              <div className="font-bold text-xl text-gray-900" data-id="element-191">+500</div>
              <div className="text-xs text-gray-500" data-id="element-192">profes confían</div>
            </div>
            <div data-id="element-193">
              <div className="font-bold text-xl text-gray-900" data-id="element-194">12+6</div>
              <div className="text-xs text-gray-500" data-id="element-195">Tomos + Bonus</div>
            </div>
            <div data-id="element-196">
              <div className="flex items-center justify-center gap-1 font-bold text-xl text-gray-900" data-id="element-197">
                4.9/5{' '}
                <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-198" />
              </div>
              <div className="text-xs text-gray-500" data-id="element-199">calificación</div>
            </div>
            <div data-id="element-200">
              <div className="font-bold text-xl text-gray-900" data-id="element-201">🇦🇷</div>
              <div className="text-xs text-gray-500" data-id="element-202">Argentina</div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}